import {
  Grid2,
  PaymentFailedDialog,
  PaymentSuccessDowngradeDialog,
  PaymentSuccessUpgradeDialog,
} from '@aibees/shared/components';
import { PlanCard } from '@aibees/shared/features';
import { useResponsive } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { Box } from '@mui/material';
import { memo } from 'react';
import { AgencyAndEnterpriseCard } from '../agency-and-enterprise-card';
import { VideoCard } from '../video-card';
import { FREE_PLAN_CONFIG, USAGE_BASED_PLAN_CONFIG } from './config';
import { usePlanList } from './hooks/use-plan-list';
import * as Styled from './styles';
import * as SX from './sx';
import type { PricingCardsProps as Props } from './types';

export const PricingCards = memo(({ className, yearly }: Props) => {
  const { plans, freePlan, isLoading } = usePlanList(yearly);
  const isSmall = useResponsive('down', 'sm');

  return (
    <Styled.Wrapper
      className={classnames('PricingCards', className)}
      sx={SX.root}
    >
      <Grid2 container spacing={1} columns={48}>
        <PaymentSuccessDowngradeDialog />
        <PaymentSuccessUpgradeDialog />
        <PaymentFailedDialog />
        <Grid2 xs={48} sm={isSmall ? 48 : 24} md={24} lg={12} xl={12}>
          <Box sx={SX.boxPlan}>
            <VideoCard />
          </Box>
        </Grid2>

        <Grid2 xs={48} sm={isSmall ? 48 : 24} md={24} lg={12} xl={12}>
          <Box sx={SX.boxPlan}>
            <PlanCard
              plans={freePlan ? [freePlan] : []}
              yearly={yearly}
              isFree
              config={FREE_PLAN_CONFIG}
              isLoading={isLoading}
            />
          </Box>
        </Grid2>
        <Grid2 xs={48} sm={isSmall ? 48 : 24} md={24} lg={12} xl={12}>
          <Box sx={SX.boxPlan}>
            <PlanCard
              plans={plans?.filter((p) => !!p.amount) ?? []}
              yearly={yearly}
              config={USAGE_BASED_PLAN_CONFIG}
              isLoading={isLoading}
            />
          </Box>
        </Grid2>
        <Grid2 xs={48} sm={isSmall ? 48 : 24} md={24} lg={12} xl={12}>
          <Box sx={SX.boxPlan}>
            <AgencyAndEnterpriseCard />
          </Box>
        </Grid2>
      </Grid2>
    </Styled.Wrapper>
  );
});

PricingCards.displayName = 'PricingCards';
